import { toComparableText } from '@/utils/textValue';

const FILTER_KEYS = ['status', 'size', 'type', 'sector', 'origin', 'file', 'area'];

export const createDefaultCustomerFilters = () => ({
  status: [],
  size: [],
  type: [],
  sector: [],
  origin: [],
  file: [],
  area: [],
});

export const normalizeCustomerFilters = (filters) => {
  const normalized = filters && typeof filters === 'object' ? filters : {};

  const next = {
    ...createDefaultCustomerFilters(),
    ...normalized,
  };

  FILTER_KEYS.forEach((key) => {
    next[key] = Array.isArray(next[key]) ? next[key] : [];
  });

  return next;
};

export const buildCustomersListParams = ({
  searchTerm,
  filters,
}) => {
  const normalizedFilters = normalizeCustomerFilters(filters);

  return {
    search: String(searchTerm || '').trim(),
    status: normalizedFilters.status,
    size: normalizedFilters.size,
    type: normalizedFilters.type,
    sector: normalizedFilters.sector,
    origin: normalizedFilters.origin,
    file: normalizedFilters.file,
    area: normalizedFilters.area,
  };
};

export const buildCustomersMetricsParams = (filters) => {
  const normalizedFilters = normalizeCustomerFilters(filters);

  return {
    status: normalizedFilters.status,
    size: normalizedFilters.size,
    type: normalizedFilters.type,
    sector: normalizedFilters.sector,
    origin: normalizedFilters.origin,
    file: normalizedFilters.file,
    area: normalizedFilters.area,
  };
};

export const matchesCustomersSearch = (row, searchTerm) => {
  const search = toComparableText(searchTerm);
  if (!search) {
    return true;
  }

  const haystack = [
    row?.name,
    row?.email,
    row?.main_contact_name,
    row?.main_contact?.name,
  ]
    .map((value) => toComparableText(value))
    .join(' ');

  return haystack.includes(search);
};
export const filterCustomersRowsLocal = (rows, searchTerm) => {
  const sourceRows = Array.isArray(rows) ? rows : [];

  return sourceRows.filter((row) => {
    return matchesCustomersSearch(row, searchTerm);
  });
};
